// Helper function to add event listeners on future added DOM elements.
// Example:
// 	
// customEventListener('element', 'click', res => {
// 	console.log(res.target.value);
// });
//
// https://dev.to/akhil_001/adding-event-listeners-to-the-future-dom-elements-using-event-bubbling-3cp1

const customEventListener = (selector, event, handler) => {
	const rootElement = document.querySelector('body');
	rootElement.addEventListener(event, evt => {
		let targetElement = evt.target;
		while (targetElement != null) {
			if (targetElement.matches(selector)) {
				handler(evt);
				return;
			}
			targetElement = targetElement.parentElement;
		}
	}, true);
};

export { customEventListener };